export default "__VITE_ASSET__BRkKNjhL__"